var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState } from 'react';
import AdminMediaResource from "../../../../api/AdminMediaResource";
import { useFetcher } from 'rest-hooks';
import { toast } from "react-hot-toast";
function mediaUploadHandler() {
    const uploadMedia = useFetcher(AdminMediaResource.createShape());
    const [uploading, setUploading] = useState(false);
    const mediaUpload = useCallback((upload) => __awaiter(this, void 0, void 0, function* () {
        setUploading(true);
        var data = new FormData();
        data.append('media', upload.filesList[0]);
        try {
            let media = yield uploadMedia({}, data);
            if (media.id === '' || media.id === undefined) {
                throw new Error("Erreur lors de l'upload");
            }
            upload.onFileChange([
                {
                    id: media.id,
                    alt: media.id,
                    url: '/api/media/' + media.id,
                    size: parseFloat(media.size),
                },
            ]);
            toast.success("Le fichier " + upload.filesList[0].name + " a été uploadé avec succès");
        }
        catch (e) {
            console.error(e);
            toast.error("Erreur lors de l'upload du fichier " + upload.filesList[0].name);
        }
        setUploading(false);
    }), [uploadMedia]);
    return { mediaUpload, uploading };
}
export default mediaUploadHandler;
//# sourceMappingURL=mediaUpload.js.map